import { useState } from "react";
import { siteFaqs } from "@/mocks/fancha";

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100/60 py-12 md:py-16">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <p className="text-xs font-semibold uppercase tracking-widest text-accent-600">FAQ</p>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            关于反差吃瓜，你关心的问题
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">
            关于我们的定位、内容来源、投稿方式与转载规则，一次说清楚。
          </p>
        </div>

        <div className="mt-8 space-y-3">
          {siteFaqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-2xl border border-background-200/70 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                  aria-expanded={isOpen}
                >
                  <h3 className="font-heading text-base font-bold text-foreground-900 md:text-lg">{f.q}</h3>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-background-200 text-foreground-700 transition-transform ${
                      isOpen ? "rotate-45 bg-accent-500 text-background-50" : ""
                    }`}
                  >
                    <i className="ri-add-line" />
                  </span>
                </button>
                {isOpen && (
                  <div className="border-t border-background-200/60 px-5 py-4 text-sm leading-7 text-foreground-700 md:px-6">
                    {f.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}